var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.amountOfActiveFilters() > 0)?_c('div',{attrs:{"id":"indicator"}},[_vm._v(_vm._s(_vm.amountOfActiveFilters()))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }